import initialState from './initialState.js'
import Vue from 'vue'

export const resetState = (state) => {
  clearInterval(state.updateTimer)

  const s = initialState()

  Object.keys(s).forEach(key => {
    state[key] = s[key]
  })
}

export const setChildren = (state, children) => {
  state.children = children
}

export const addChild = (state, child) => {
  state.children.push(child)
}

export const addChildDevice = (state, payload) => {
  const { child_id, device } = payload
  const index = state.children.findIndex(child => child.id === child_id)
  const child = state.children.find(child => child.id === child_id)

  child.devices.push(device)

  Vue.set(state.children, index, child)
}

export const updateChildDevice = (state, payload) => {
  const { child_id, device_id, attributes } = payload
  const child = state.children.find(child => child.id === child_id)
  const childIndex = state.children.findIndex(child => child.id === child_id)
  const device = child.devices.find(device => device.id === device_id)
  const deviceIndex = child.devices.findIndex(device => device.id === device_id)

  Vue.set(child.devices, deviceIndex, { ...device, ...attributes })
  Vue.set(state.children, childIndex, child)
}

export const updateChild = (state, payload) => {
  const { child_id, attributes } = payload
  const index = state.children.findIndex(child => child.id === child_id)

  Vue.set(state.children, index, { ...state.children[index], ...attributes })
}

export const updateChildStatus = (state, payload) => {
  const { child_id, status } = payload
  const child = state.children.find(child => child.id === child_id)
  const index = state.children.findIndex(child => child.id === child_id)

  child.status.active = status

  Vue.set(state.children, index, child)
}

export const updateChildSettings = (state, payload) => {
  const { child_id, attributes } = payload
  const index = state.children.findIndex(child => child.id === child_id)

  Vue.set(state.children, index, {
    ...state.children[index],
    settings: {
      ...state.children[index].settings,
      ...attributes
    }
  })
}

export const setLastSeen = (state, payload) => {
  const { device_id, last_seen } = payload

  state.children.forEach(child => {
    child.devices = child.devices.map(device => {
      if (device.id === device_id) {
        return {
          ...device,
          last_seen
        }
      }

      return device
    })
  })
}

export const changePrimaryDevice = (state, payload) => {
  const {childId, deviceId} = payload
  const child = state.children.find(child => child.id === childId)
  const index = state.children.findIndex(child => child.id === childId)

  child.primary_device_id = deviceId

  Vue.set(state.children, index, child)
}

export const removeChildDevice = (state, deviceId) => {
  state.children.forEach(child => {
    child.devices = child.devices.filter(device => {
      return device.id !== deviceId
    })
  })
}

export const removeChild = (state, childId) => {
  state.children = state.children.filter(child => child.id !== childId)
}

export const setSearches = (state, payload) => {
  const { user_id, searches } = payload
  const index = state.children.findIndex(child => child.id === user_id)

  Vue.set(state.children, index, {
    ...state.children[index],
    searches
  })

}

export const setYoutubeSearches = (state, payload) => {
  const { user_id, youtube_searches } = payload
  const index = state.children.findIndex(child => child.id === user_id)

  Vue.set(state.children, index, {
    ...state.children[index],
    youtube_searches
  })
}

export const setYoutubeViews = (state, payload) => {
  const { user_id, youtube_views } = payload
  const index = state.children.findIndex(child => child.id === user_id)

  Vue.set(state.children, index, {
    ...state.children[index],
    youtube_views
  })
}

export const setBlocksAndAlerts = (state, payload) => {
  const { user_id, blocks_and_alerts } = payload
  const index = state.children.findIndex(child => child.id === user_id)

  Vue.set(state.children, index, {
    ...state.children[index],
    blocks_and_alerts
  })
}

export const addSearchEvent = (state, payload) => {
  const { user_id, device_event } = payload
  const child = state.children.find(child => child.id === user_id)
  const index = state.children.findIndex(child => child.id === user_id)

  if (_.has(child, 'searches')) {
    const searches = child.searches.filter(search => search.id !== device_event.id)
    searches.unshift(device_event)
    child.searches = searches

    Vue.set(state.children, index, child)
  }
}

export const addYoutubeSearchEvent = (state, payload) => {
  const { user_id, device_event } = payload
  const child = state.children.find(child => child.id === user_id)
  const index = state.children.findIndex(child => child.id === user_id)

  if (_.has(child, 'youtube_searches')) {
    const searches = child.youtube_searches.filter(search => search.id !== device_event.id)
    searches.unshift(device_event)
    child.youtube_searches = searches

    Vue.set(state.children, index, child)
  }
}

export const addYoutubeViewEvent = (state, payload) => {
  const { user_id, youtube_event } = payload
  const child = state.children.find(child => child.id === user_id)
  const index = state.children.findIndex(child => child.id === user_id)

  if (_.has(child, 'youtube_views')) {
    child.youtube_views.unshift(youtube_event)
    Vue.set(state.children, index, child)
  }
}

export const addBlocksAndAlertsEvent = (state, payload) => {
  const { user_id, device_event } = payload
  const child = state.children.find(child => child.id === user_id)
  const index = state.children.findIndex(child => child.id === user_id)

  if (_.has(child, 'blocks_and_alerts')) {
    child.blocks_and_alerts.unshift(device_event)
    Vue.set(state.children, index, child)
  }
}

export const setCategorySettings = (state, payload) => {
  const { user_id, category_settings } = payload
  const index = state.children.findIndex(child => child.id === user_id)

  Vue.set(state.children, index, {
    ...state.children[index],
    category_settings
  })
}

export const updateCategorySettings = (state, payload) => {
  const { user_id, category_settings } = payload
  const child = state.children.find(child => child.id === user_id)
  const childIndex = state.children.findIndex(child => child.id === user_id)

  if (_.has(child, 'category_settings')) {
    const settings = child.category_settings.filter(setting => {
      return setting.id !== category_settings.id
    })

    settings.push(category_settings)

    Vue.set(state.children, childIndex, {
      ...child,
      category_settings: settings
    })
  }
}

export const removeCategorySettings = (state, payload) => {
  const { user_id, category_id } = payload
  const child = state.children.find(child => child.id === user_id)
  const index = state.children.findIndex(child => child.id === user_id)

  if (_.has(child, 'category_settings')) {
    const settings = child.category_settings.filter(setting => {
      return setting.id !== category_id
    })

    Vue.set(state.children, index, {
      ...child,
      category_settings: settings
    })
  }
}

export const setAppSettings = (state, payload) => {
  const { user_id, app_settings } = payload
  const child = state.children.find(child => child.id === user_id)
  const index = state.children.findIndex(child => child.id === user_id)

  child.app_settings = app_settings

  Vue.set(state.children, index, child)
}

export const setProtectedSocialMedia = (state, payload) => {
  const { user_id, protected_social_media_settings } = payload
  const child = state.children.find(child => child.id === user_id)
  const index = state.children.findIndex(child => child.id === user_id)

  child.protected_social_media_settings = protected_social_media_settings

  Vue.set(state.children, index, child)
}

export const setUnsupportedSocialMedia = (state, payload) => {
  const { user_id, unsupported_social_media_settings } = payload
  const child = state.children.find(child => child.id === user_id)
  const index = state.children.findIndex(child => child.id === user_id)

  child.unsupported_social_media_settings = unsupported_social_media_settings

  Vue.set(state.children, index, child)
}

export const updateProtectedSocialMedia = (state, payload) => {
  const { user_id, social_media_setting } = payload
  const child = state.children.find(child => child.id === user_id)
  const index = state.children.findIndex(child => child.id === user_id)

  if (_.has(child, 'protected_social_media_settings')) {
    const setting = child.protected_social_media_settings.find(setting => {
      return setting.app_name === social_media_setting.app_name
    })

    if (!setting) {
      return
    }

    const settings = child.protected_social_media_settings.filter(setting => {
      return setting.app_name !== social_media_setting.app_name
    })

    settings.push({
      ...social_media_setting,
      icon_url: setting.icon_url,
      supports_protection: setting.supports_protection
    })

    Vue.set(state.children, index, {
      ...child,
      protected_social_media_settings: settings
    })
  }
}

export const updateUnsupportedSocialMedia = (state, payload) => {
  const { user_id, social_media_setting } = payload
  const child = state.children.find(child => child.id === user_id)
  const index = state.children.findIndex(child => child.id === user_id)

  if (_.has(child, 'unsupported_social_media_settings')) {
    const setting = child.unsupported_social_media_settings.find(setting => {
      return setting.app_name === social_media_setting.app_name
    })

    if (!setting) {
      return
    }

    const settings = child.unsupported_social_media_settings.filter(setting => {
      return setting.app_name !== social_media_setting.app_name
    })

    settings.push({
      ...social_media_setting,
      icon_url: setting.icon_url,
      supports_protection: setting.supports_protection
    })

    Vue.set(state.children, index, {
      ...child,
      unsupported_social_media_settings: settings
    })
  }
}

export const setBlockableApps = (state, payload) => {
  const { child_id, android_apps, ios_apps } = payload
  const child = state.children.find(child => child.id === child_id)
  const index = state.children.findIndex(child => child.id === child_id)

  child.android_apps = android_apps
  child.ios_apps = ios_apps

  Vue.set(state.children, index, child)
}

export const updateAppSettings = (state, payload) => {
  const { user_id, app_settings } = payload
  const child = state.children.find(child => child.id === user_id)
  const childIndex = state.children.findIndex(child => child.id === user_id)

  if (_.has(child, 'app_settings')) {
    const settings = child.app_settings.filter(setting => {
      return setting.id !== app_settings.id
    })

    settings.push(app_settings)

    Vue.set(state.children, childIndex, {
      ...child,
      app_settings: settings
    })
  }
}

export const setUrlSettings = (state, payload) => {
  const { user_id, url_settings } = payload
  const index = state.children.findIndex(child => child.id === user_id)

  Vue.set(state.children, index, {
    ...state.children[index],
    url_settings
  })
}

export const addUrlSettings = (state, payload) => {
  const { user_id, url_settings } = payload
  const child = state.children.find(child => child.id === user_id)

  if (_.has(child, 'url_settings')) {
    child.url_settings.push(url_settings)
  }
}

export const removeUrlSettings = (state, payload) => {
  const { user_id, url_settings } = payload
  const child = state.children.find(child => child.id === user_id)
  const index = state.children.findIndex(child => child.id === user_id)

  if (_.has(child, 'url_settings')) {
    const settings = child.url_settings.filter(setting => {
      return setting.id !== url_settings.id
    })

    Vue.set(state.children, index, {
      ...child,
      url_settings: settings
    })
  }
}